module.exports = "<p style=\"margin-left:300px; margin-top:200px;\">\r\n  viewproduct works!\r\n</p>\r\n"